import {
  ProposalBillingRequestInterface
} from '../../../../interfaces/request/client-portal/proposal-billing/proposal-billing-request-interface';
import { ProposalsRequestModel } from '@fh-client-interaction-frontends/fh-sales-portal-service';

export class ProposalBillingRequestModel implements ProposalBillingRequestInterface {
  id: number = -1;
  fractioningDescription: string = "";
  paymentMethodCode: string = "";

  constructor(init?: Partial<ProposalsRequestModel>) {
    Object.assign(this, init);
  }
}
